import { useState } from 'react';
import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { UnavailableIndicator } from './UnavailableIndicator';

type QaResultIndicatorProps = {
  // null means the QA result is unavailable, not that QA failed.
  qaPassed: boolean | null;
  qaRationale: string | null;
};

/** Pass/Fail chip; clicking it opens the rationale in a dialog. */
export const QaResultIndicator = ({
  qaPassed,
  qaRationale,
}: QaResultIndicatorProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Box sx={{ minWidth: 140 }}>
      <Typography variant="caption" color="text.secondary" display="block">
        QA result
      </Typography>
      {qaPassed == null ? (
        <UnavailableIndicator />
      ) : (
        <>
          <Chip
            label={qaPassed ? 'Pass' : 'Fail'}
            color={qaPassed ? 'success' : 'error'}
            size="small"
            variant="outlined"
            onClick={() => setOpen(true)}
            sx={{ cursor: 'pointer' }}
          />
          <Dialog
            open={open}
            onClose={() => setOpen(false)}
            maxWidth="sm"
            fullWidth
            slotProps={{
              backdrop: { sx: { backdropFilter: 'blur(3px)' } },
            }}
          >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              QA result — {qaPassed ? 'Pass' : 'Fail'}
              <IconButton onClick={() => setOpen(false)} size="small">
                <CloseIcon fontSize="small" />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ maxHeight: '70vh' }}>
              <Typography
                variant="body1"
                sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
              >
                {qaRationale ?? 'No rationale provided.'}
              </Typography>
            </DialogContent>
          </Dialog>
        </>
      )}
    </Box>
  );
};
